// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Order_componentWrapper__MtKWM","company":"Order_company__l7qpg","title":"Order_title__Kg+56","label":"Order_label__uxAbz"};